import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import WebauthnAuthOptionModel from 'donor-elf-web/models/webauthn/auth-option';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export interface PasskeysLoginModel {
  authOption: WebauthnAuthOptionModel;
}

export default class PasskeysAddRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'Passkey Login';
  }

  async model() {
    let authOption = await this.store.queryRecord('webauthn/auth-option', {
      filter: {},
    });
    return {
      authOption,
    };
  }
}
